module.exports = __webpack_public_path__ + "img/sort-numeric-up.cb117e89.svg";